<!-- 智能批量装箱 -->
<template>
    <div class="container">
        <div class="content">
            <Form label-position="right" :label-width="100">
                <div class="header">
                    <img  class="width_height_24 mr-12" src="../../assets/information.png">
                    <div style="color: #FF761D;">
                        <div >1.通过该功能，可以将采集到的装箱数据导入的方式批量装箱操作。</div>
                        <div>2.我们建议先自由编辑好箱码，然后印刷（打印）成标签贴在箱子上，采集产品码和箱码数据，通过该功能进行批量智能装箱处理</div>
                        <div>3.溯源码，箱码均支持编码和内容（即带网址链接的内容），系统会自动处理分析。</div>
                    </div>
                </div>
                <FormItem label="第一步：">
                    <Button class="download_btn" type="success" @click="goDownload">点击下载模板范本</Button>
                    <Tooltip max-width="250" placement="right" theme="light">
                        <Icon class="ml-24 cursor-p" type="md-help-circle" size="20" color="#FF761D"/>
                        <div slot="content">
                            <p>请先下载采集的模板范本。数据请勿必按范本正确填写！</p>
                        </div>
                    </Tooltip>
                </FormItem>
                <FormItem label="第二步：">
                    <div class="form_div">
                        <div class="form_upload mr-24">
                            <Upload
                            :auto-upload="false"
                            :on-success="handleSuccess"
                            class="ta-c"
                            ref="upload"
                            :show-upload-list="false"
                            :format="['gif', 'pem', 'xls']"
                            :max-size="2048"
                            :on-format-error="handleFormatError"
                            :on-progress="handleProgress"
                            :headers="headers"
                            :action="uploadImg"
                            :before-upload="handleBeforeUpload"
                            >
                                <Icon type="ios-add" size="40" color="#AEAEB3"/>
                                <div>（5M以内）</div>
                            </Upload>
                        </div>
                        <div v-if="formData.file" class="file_div">
                            <div class="delete_div"><Icon type="ios-close-circle-outline" color="#F00" size="20" @click="goDelete"/></div>
                            {{formData.file_name}}
                        </div>
                        <Tooltip max-width="250" placement="right" theme="light">
                            <Icon class="ml-24 cursor-p" type="md-help-circle" size="20" color="#FF761D"/>
                            <div slot="content">
                                <p>1.采集的数据以溯源码为基准进行判断修改,溯源码数据项必填。</p>
                                <p>2.当该溯源码已经装过箱时,系统会自动智能过滤该条记录！</p>
                                <p>3.如果系统中存在相同的箱码,系统会将相同箱码的数据合并。</p>
                            </div>
                        </Tooltip>
                    </div>
                </FormItem>
                <div class="footer">
                    <Button class="mr-24" @click="goRecord">导入记录</Button>
                    <Button class="theme-bg" type="warning" @click="goSubmit">导入批量装箱</Button>
                </div>
            </Form>
        </div>
        <!-- 导入记录 -->
        <Drawer v-model="recordDrawer" title="导入记录" width="80">
            <Table :columns="columnsRecord" :data="dataRecord" border>
                <template slot-scope="{ index }" slot="id">
                    <div>{{ index + 1 }}</div>
                </template>
                <template slot-scope="{ row }" slot="nums">
                    <div>{{row.success_num}}/{{row.nums}}</div>
                </template>
                <template slot-scope="{ row }" slot="status_text">
                    <div>{{row.status_text}}</div>
                </template>
                <template slot-scope="{ row }" slot="operate">
                    <div class="flex-sa">
                        <Button type="primary" ghost label="small" @click="goCheck(row)">查看</Button>
                    </div>
                </template>
            </Table>
            <div class="page">
                <Page :current="pageRecord.page" :page-size="pageRecord.limit" :total="totalRecord"  show-elevator show-total @on-change="changeRecord"/>
            </div>
        </Drawer>
        <!-- 查看 -->
        <Modal v-model="checkModal" title="查看" width="40">
            <div v-html="reason"></div>
            <div slot="footer"></div>
        </Modal>
    </div>
</template>

<script>
import { 
    packing_intelligence_lis,
} from '@/api/index';
import config from "@/config/index";
import { getCookies } from "@/utils/helper";
export default {
    data() {
        return {
            reason: "",
            uploadImg: config.apiUrl + "/api/packing/intelligence",
            headers: { 
                "hlzw-suyuan-token": getCookies("pcToken")
            },
            avatarList: [
                { src: '@/assets/example1.png' },
            ],
            recordDrawer: false,
            pageRecord: {
                page: 1,
                limit: 10,
            },
            totalRecord: 0,
            columnsRecord: [
                { title: "#", slot: "id", align: "center", width: "60px" },
                { title: "文件名", key: "name", align: "center" },
                { title: "数量", slot: "nums", align: "center" },
                { title: "状态", slot: "status_text", align: "center" },
                { title: "导入时间", key: "created_at", align: "center" },
                { title: "操作", slot: "operate", align: "center" },
            ],
            dataRecord: [],
            demo_file_path: "",
            checkModal: false,
            loadingStatus: false,
            formData: {
                file_name: '',
                file: '',
            },
        };
    },
    created() {
        this.demo_file_path = localStorage.getItem('demo_file_path');
    },
    mounted() {
    },
    methods: {
        getList(){
            packing_intelligence_lis(this.pageRecord).then((res) => {
                this.dataRecord = res.data.data;
                this.totalRecord = res.data.total;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        changeRecord(index){
            this.pageRecord.page = index;
            this.getList();
        },
        goRecord(){
            this.getList();
            setTimeout(() => {
                this.recordDrawer = true;
            }, 300);
        },
        // 下载模板范本
        goDownload(){
            if(this.demo_file_path){
                window.open(this.demo_file_path);
            }else{
                return this.$Message.error("暂无模板范本");
            }
        },
        goCheck(row){
            this.reason = row.reason;
            this.checkModal = true;
        },
        handleBeforeUpload (file) {
            this.formData.file_name = file.name;
            this.formData.file = file; //暂存文件
            this.$Message.destroy();
            return false; //阻止自动上传
        },
        // 文件上传时
        handleProgress(){
            this.$Message.loading({
                content: '上传中...',
                duration: 0
            }) 
        },
        // 文件上传类型错误
        handleFormatError(){                
            this.$Message.destroy();
            this.$Message.warning("暂不支持上传此格式");
        },
        // 上传成功回调
        handleSuccess(e) {
            this.loadingStatus = false;
            this.$Message.destroy();
            this.$Message.success('批量导入成功！');
            this.formData.file = '';
            this.formData.file_name = '';
        },
        goSubmit(){
            if (!this.formData.file) {
                this.$Message.error('请先上传文件');
                return;
            }
            this.loadingStatus = true;
            this.$refs.upload.post(this.formData.file);
        },
        goDelete(){
            this.formData.file = '';
            this.formData.file_name = '';
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.header {
    margin-bottom: 12px;
    padding: 24px;
    display: flex;
    align-items: center;
}
.width_height_24 {
    width: 24px;
    height: 24px;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.form_upload {
    width: 80px;
    height: 80px;
    background: #FFFFFF;
    border-radius: 5px;
    border: 1px solid #9FA5BB;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}
.footer {
    margin: 12px 0 0 0;
    padding: 24px 0 0 0;
    text-align: center;
    border-top: 1px solid #eee;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
.download_btn {
    background: #53C41A;
    margin: 0 24px 0 0;
}
.form_div {
    display: flex;
    align-items: center;
}
.page {
    text-align: right;
    margin: 24px 0 0 0;
}
.file_div {
    width: 80px;
    height: 80px;
    font-size: 12px;
    color: #9FA5BB;
    background: #FFFFFF;
    border-radius: 5px;
    border: 1px solid #9FA5BB;
    text-align:center;
    position: relative;
    overflow: hidden;
}
.delete_div {
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
}
</style>